import { Vue } from 'vue-property-decorator';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { API_URL } from '@/App.settings';
import Dictionary from "@/types/Dictionary";
import NewsNotification from '@/types/NewsNotification';

/** Store VueX pour la gestion des notifications */
@Module({
    namespaced: true
})
class NotificationsStore extends VuexModule {
    //#region Data
    /** Liste des notifications à l'ouverture de la session */
    private newsAtBeginning: NewsNotification[] = [];

    /** Liste des news au click du bouton notification dans le Header */
    private newsNotifications: NewsNotification[] = [];

    /** Notification séléctionnée par l'utilisateur */
    private currentNotification: NewsNotification | null = null;

    /** Gestion de l'Etat d'affichage de la modal des news notifications */
    private isNewsVisible: boolean = false;

    /** Gestion de l'Etat d'affichage de la modal de la SearchNews */
    private isSearchNewsVisible: boolean = false;

    //#endregion Data

    //#region Mutations

     /* Modifie l'etat de la liste de news notification qui s'affiche au début de la session*/
    @Mutation
    private setNewsAtBeginningNotifications(newsAtBeginning: NewsNotification[]) {
        this.newsAtBeginning = newsAtBeginning.map(newsNotification => ({ ...newsNotification }));
        console.debug('NotificationStore:  setNewsAtBeginningNotifications', this.newsAtBeginning);
    }

    /* Modifie l'etat de la liste de news notification */
    @Mutation
    private setNewsNotifications(newsNotifications: NewsNotification[]) {
        this.newsNotifications = newsNotifications.map(newsNotification => ({ ...newsNotification }));
        console.debug('NotificationStore:  setNewsNotifications', this.newsNotifications);
    }

    /* Modifie l'etat de la news notification courante */
    @Mutation
    private setCurrentNewsNotification(notification: NewsNotification | null){
        this.currentNotification = notification;
        console.debug('NotificationStore: setCurrentNewsNotification', notification);
    }

    /* Modifie l'Etat de la modal de news au début de la session */
    @Mutation
	private setIsNewsVisible (value: boolean) {
		this.isNewsVisible = value;
        console.debug('NotificationStore: setIsNewsVisible', this.isNewsVisible);
	}

    /* Modifie l'Etat de la modal de search news  */
    @Mutation
	private setIsSearchNewsVisible (value: boolean) {
		this.isSearchNewsVisible = value;
        console.debug('NotificationStore: setIsSearchNewsVisible', this.isSearchNewsVisible);
	}

    @Mutation
    private reset() {
        this.newsAtBeginning = [];
        this.newsNotifications = [];
    }
    //#endregion Mutations

    //#region Actions
    @Action({ rawError: true })
    public async LoadNews(newsRef: string){
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["NewsRef"] = newsRef;

        await axios.post<NewsNotification>(`${API_URL}News/GetNews`, args).then(response => {
            if (response && response.data) {
                this.context.commit('setCurrentNewsNotification', response.data);
            }
        });
    }


    @Action({ rawError: true })
       /** Action pour récupérer la liste des news au click du bouton notification dans le Header*/
    public async LoadNewsNotifications(lazy) {
        // let currentNews = this.currentNotification;

        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Lazy"] = lazy;
        await axios.post<NewsNotification[]>(`${API_URL}News/GetNewsWithReadStatus`,args).then(response=>{
            if (response && response.data && Array.isArray(response.data)) {
                this.context.commit('setNewsNotifications', response.data);

                // Resélectionne
                // this.context.commit('setCurrentNewsNotification', currentNews);
            }
        });
    }

    /** Action pour récupérer la liste des news à afficher au début de la session */
    @Action({ rawError: true})
    public async GetNewsManagerAtBeginning(){
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        await axios.post<NewsNotification[]>(`${API_URL}News/GetNewsManagerAtBeginning`, args).then((response) => {
            if (response && response.data && Array.isArray(response.data)) 
                this.context.commit('setNewsAtBeginningNotifications', response.data);
        });
    }

    /** Action qui marque la news selectionnée comme lue */
    @Action({rawError: true})
    public async MarkNewsAsRead(){
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["NewsId"] =  this.currentNotification.Id
        await axios.post<number>(`${API_URL}News/MarkAsRead`,args);
    }

    /** Action qui marque toutes les news comme lues */
    @Action({ rawError: true})
    public async MarkAllNewsAsRead(){
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        await axios.post<number>(`${API_URL}News/MarkAllNewsAsRead`,args);
    }

    /** Action Pour selectionner l'id d'une news de notification */
    @Action({ rawError: true})
    public SetCurrentNewsNotification(notification: NewsNotification | null){
        this.context.commit('setCurrentNewsNotification', notification)
    }

    /** Permet d'afficher la modal des news */
    @Action({ rawError: true})
    public DisplayNews(){
        this.context.commit('setIsNewsVisible', true)
    }
    /** Permet de cacher la modal de news */
    @Action({ rawError: true})
    public HideNews(){
        this.context.commit('setIsNewsVisible', false)
    }

    /** Permet d'afficher la modal SearchNews */
    @Action({ rawError: true})
    public DisplaySearchNews(){
        this.context.commit('setIsSearchNewsVisible', true)
    }

    /** Permet de cacher la modal de SearchNews */
    @Action({ rawError: true})
    public HideSearchNews(){
        this.context.commit('setIsSearchNewsVisible', false)
    }

    /** Réinitialise le store */
    @Action({ rawError: true })
    public Reset() {
        this.context.commit('reset')
    }
    //#endregion Actions


    //#region Getters
    /** Retourne la liste des news lors de l'ouverture de la session  */
    public get GetNewsAtBeginningNotifications(): NewsNotification[] {
        return this.newsAtBeginning;
    }

    /** Retourne la liste des news lors du click du bouton notification dans le header */
    public get GetNewsNotifications(): NewsNotification[] {
        return this.newsNotifications;
    }

    /** Notification actuellement sélectionnée */
    public get GetSelectedNewsNotification(): NewsNotification | null {
        return this.currentNotification !== null 
            ? this.currentNotification : null;
    }

    /** Retourne l'etat de l'affichage news modale visible/non visible  */
    public get GetIsNewsVisible(): boolean {
		return this.isNewsVisible;
	}

    /** Retourne l'etat de l'affichage SearchNews modale visible/non visible  */
    public get GetIsSearchNewsVisible(): boolean {
		return this.isSearchNewsVisible;
	}

    /** Retourne si on doit afficher une seule news ou toutes les news */
    public get ShouldDisplaySingleNews(): boolean {
        return this.currentNotification !== null;
    }

    //#endregion
}

export default NotificationsStore;